import type { MainContentTab, SidebarTab } from '../store/layoutStore';

const BI_SIDEBAR_TAB_PAGE_NAMES: Record<SidebarTab, string> = Object.freeze({
  dashboard: 'DASHBOARD',
  'network-graph': 'NETWORK_GRAPH',
  signals: 'SIGNALS',
  assets: 'ASSETS',
  findings: 'FINDINGS',
  reports: 'REPORTS',
  executions: 'EXECUTIONS',
  code: 'CODE',
  skills: 'SKILLS',
  requests: 'REQUESTS',
  websocket: 'WEBSOCKET',
  intercept: 'INTERCEPT',
  'match-replace': 'MATCH_REPLACE',
  replay: 'REPLAY',
  comparer: 'COMPARER',
  interact: 'INTERACT',
  'agent-executions': 'AGENT_EXECUTIONS',
  'proxy-settings': 'PROXY_SETTINGS',
  settings: 'SETTINGS',
});

const BI_MAIN_CONTENT_TAB_PAGE_NAMES: Record<MainContentTab, string> =
  Object.freeze({
    welcome: 'WELCOME',
    application: 'APPLICATION',
    endpoint: 'ENDPOINT_DETAILS',
    'unverified-endpoint': 'UNVERIFIED_ENDPOINT_DETAILS',
    domain: 'DOMAIN_DETAILS',
    webpage: 'WEBPAGE_DETAILS',
    settings: 'SETTINGS',
    requests: 'REQUESTS',
    websocket: 'WEBSOCKET',
    intercept: 'INTERCEPT',
    'match-replace': 'MATCH_REPLACE',
    replay: 'REPLAY',
    'proxy-settings': 'PROXY_SETTINGS',
    comparer: 'COMPARER',
    executions: 'EXECUTIONS',
    'agent-execution': 'AGENT_EXECUTION',
    signal: 'SIGNAL_DETAILS',
    finding: 'FINDING_DETAILS',
    interact: 'INTERACT',
    'signals-list': 'SIGNALS',
    'findings-list': 'FINDINGS',
    'reports-list': 'REPORTS',
    'executions-list': 'EXECUTIONS',
    'assets-list': 'ASSETS',
    'code-list': 'CODE',
    'skills-list': 'SKILLS',
    skill: 'SKILL_DETAILS',
    'skill-editor': 'SKILL_EDITOR',
    'hitl-edit': 'HITL_EDIT',
    'http-viewer': 'HTTP_VIEWER',
    'node-args-viewer': 'NODE_ARGS_VIEWER',
    'browser-stream': 'BROWSER_STREAM',
    'plan-viewer': 'PLAN_VIEWER',
    'agent-executions-list': 'AGENT_EXECUTIONS',
    'co-pilot-execution': 'CO_PILOT_EXECUTION',
    'surface-asset': 'SURFACE_ASSET_DETAILS',
    'ai-component': 'AI_COMPONENT_DETAILS',
    'network-graph': 'NETWORK_GRAPH',
  });

export type BISidebarPageName = (typeof BI_SIDEBAR_TAB_PAGE_NAMES)[SidebarTab];
export type BIMainContentPageName =
  (typeof BI_MAIN_CONTENT_TAB_PAGE_NAMES)[MainContentTab];
export type BIPageName = BISidebarPageName | BIMainContentPageName;

export type TorchPageViewContext = {
  sidebarTab: SidebarTab;
  activeTabId?: string;
  activeTabType?: MainContentTab;
  activePageId?: string;
  activePageType?: MainContentTab;
  activePageIndex?: number;
};

export const buildTorchPageViewKey = ({
  sidebarTab,
  activeTabId,
  activePageId,
  activePageIndex,
}: TorchPageViewContext): string => {
  return [
    `sidebar:${sidebarTab}`,
    `tab:${activeTabId ?? ''}`,
    `page:${activePageId ?? ''}`,
    `index:${activePageIndex ?? 0}`,
  ].join('|');
};

export const resolveTorchPageName = ({
  sidebarTab,
  activeTabType,
  activePageType,
}: TorchPageViewContext): BIPageName => {
  if (activePageType) {
    return BI_MAIN_CONTENT_TAB_PAGE_NAMES[activePageType];
  }

  if (activeTabType) {
    return BI_MAIN_CONTENT_TAB_PAGE_NAMES[activeTabType];
  }

  return BI_SIDEBAR_TAB_PAGE_NAMES[sidebarTab];
};
